import { css, Global } from "@emotion/react";
import type { ComponentPropsWithoutRef } from "react";

import { PageFooter, PageHeader } from "./Page.js";

export const FormattedPdfDocument = (
  props: ComponentPropsWithoutRef<"div"> & {
    header: string;
    footer: string;
  },
) => {
  const { header, children, footer, ...others } = props;

  return (
    <>
      <Global
        styles={css`
          @page {
            // to avoid any text cut off on the pdf we need as much space as possible
            margin: 1cm 1.5cm 1cm 1.6cm;
            size: A4;
          }
        `}
      />

      <div
        css={css`
          --report-root-font-size: 11px;

          position: relative;

          font-family:
            "Lato", "Trebuchet MS", "Lucida Grande", "Lucida Sans Unicode",
            "Lucida Sans", Tahoma, sans-serif;

          font-size: var(--report-root-font-size);
          line-height: calc(1.7 * var(--report-root-font-size));

          @media screen {
            // when used for web view we want larger text than print
            --report-root-font-size: 12px;

            max-width: 21cm;
            margin: 0 auto;
            padding: 50px 0;
          }
        `}
        {...others}
      >
        <table
          css={css`
            margin: 0;
            padding: 0;
            width: 100%;
            // prevent the table to try to adapt to its content size
            table-layout: fixed;
          `}
        >
          <thead>
            <tr>
              <td>
                {/* page header will be displayed on every single page caused by "position: fixed" */}
                <PageHeader title={header} />
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{children}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                {/* page footer will be displayed on every single page caused by "position: fixed" */}
                <PageFooter title={footer} />
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );
};
